import { Alert, AlertTitle, Box } from "@mui/material";

export interface ConsolidatedEManifestAlertManifest {
  isConsolidatedEManifest?: boolean | null;
  consolidatedEManifest?: {
    generatorId?: string | null;
    generatorName?: string | null;
    vendorGeneratorId?: string | null;
  } | null;
}

/** Says why a manifest is consolidated, naming the EPA IDs involved. */
export function ConsolidatedEManifestAlert({
  manifest,
}: {
  manifest?: ConsolidatedEManifestAlertManifest | null;
}) {
  if (!manifest?.isConsolidatedEManifest) return null;
  const details = manifest.consolidatedEManifest;
  const hauler = details?.generatorId
    ? `${details.generatorId}${details.generatorName ? ` (${details.generatorName})` : ""}`
    : null;
  return (
    <Alert severity="info" variant="outlined" sx={{ mt: 2 }}>
      <AlertTitle>Consolidated e-Manifest</AlertTitle>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {hauler && <li>{hauler} is both generator and transporter in e-Manifest.</li>}
        {details?.vendorGeneratorId && (
          <li>This site&apos;s vendor record lists {details.vendorGeneratorId}.</li>
        )}
        <li>
          Route quantities and generator details aren&apos;t counted here. Amounts come from the
          vendor record.
        </li>
      </Box>
    </Alert>
  );
}
